module.exports = __webpack_public_path__ + "static/media/blackfriday.24ed6a6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/banner-carousel/blackfriday.png
// module id = 1956
// module chunks = 0